export default function initDetails() {
  const components = document.querySelectorAll("details")

  const resizeObserver = new ResizeObserver((entries) =>
    entries.forEach((entry) => {
      const element = entry.target
      const width = parseInt(element.dataset.width, 10)
      if (width !== Math.floor(entry.contentRect.width)) {
        element.removeAttribute("style")
        setHeight(element)
        setHeight(element, true)
        element.open = false
      }
    })
  )

  components.forEach((component) => {
    resizeObserver.observe(component)
  })
}

function setHeight(detail, open = false) {
  detail.open = open
  const rect = detail.getBoundingClientRect()
  detail.dataset.width = rect.width.toString()
  detail.style.setProperty(open ? `--expanded` : `--collapsed`, `${rect.height}px`)
}
